import React, { Component } from "react";
import { Field } from "redux-form";
import { required, isNumEqual9, validateEmail } from "utils/validations";
import { renderField, renderStatesField, renderTextField } from "containers/MultistepForm/Step2/input_helpers";
import { normalizeSNN } from "utils/normalize";
import DateOfBirth from "components/Fields/DateOfBirth";
import { REQUIRED_FIELD_TITLE } from "containers/MultistepForm/Step2/constants";

class PersonalInfoForm extends Component {
  render() {
    const { month, day, year, change } = this.props;
    return (
      <div>
        <div className="require-text">{REQUIRED_FIELD_TITLE}</div>
        <div className="step2__form paypair-form">
          <div className="form-item-group">
            <div className="form-item form-item--first-name">
              <Field
                name="firstName"
                normalize={null}
                validate={[required]}
                component={renderTextField}
              />
            </div>
            <div className="form-item form-item--last-name">
              <Field
                name="lastName"
                normalize={null}
                validate={[required]}
                component={renderTextField}
              />
            </div>
          </div>
          <div className="form-item-group">
            <div className="form-item form-item--ssn">
              <Field
                name="ssn"
                validate={[required, isNumEqual9]}
                component={renderField}
                normalize={normalizeSNN}
                label={"* SSN / ITIN"}
              />
            </div>
            <div className="form-item form-item--last-name">
              <Field
                name="email"
                normalize={null}
                validate={[required, validateEmail]}           
                component={renderTextField}
              />
            </div>
          </div>
          <div className="form-item-birthday">
            <div className="prequlification form-item date-of-birthday">
              <DateOfBirth
                month={month}
                day={day}
                year={year}
                resetDay={()=> change("day", '')}
              />
            </div>
          </div>
          <div className="form-item form-item--street-address">
            <Field
              name='streetAddress'
              normilize={null}
              validate={[required]}
              component={renderTextField}
            />
          </div>
          <div className="form-item-group">
            <div className="form-item form-item--city">
              <Field
                name='city'
                normilize={null}
                validate={[required]}
                component={renderTextField}
              />
            </div>
            <div className="form-item-group triple">
              <div className="form-item form-item--state">
                <Field
                  name='state'
                  normilize={null}
                  validate={[required]}
                  component={renderStatesField}
                />
              </div>
              <div className="form-item form-item--zip-code">
                <Field
                  name='zipCode'
                  normilize={null}
                  validate={[required]}
                  component={renderTextField}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PersonalInfoForm;